//Menu1.jsx
import logo from "../components/logo.png";
import "../styles/Menu1.css";

export default function Menu1() {
  return (
    <div className="metodo-container">
       <div className="metodo-text">
      <h2 style={{ marginBottom: 24 }}>MÉTODO M3</h2>

      <p>
        Después de varios años dedicándome a la docencia y a la tecnología, y
        también como padre, me di cuenta de que es vital que los jóvenes vivan
        inmersos en la tecnología desde el primer momento. No como simples
        consumidores, sino como creadores, constructores y personas capaces de
        comprenderla y mantenerla.
      </p>

      <p>
        El panorama cambia cada vez más rápido. Existen trabajos que no sabemos
        si se mantendrán, un futuro laboral inestable y un entorno en el que
        casi todo resulta incierto. Ante esta realidad, preparar a niños y
        adolescentes para lo que viene ya no es una opción: es una necesidad.
      </p>

      <p>
        Los programas curriculares de colegios e institutos siguen teniendo una
        asignatura pendiente: el aprendizaje real de las nuevas tecnologías. La
        inteligencia artificial, la hiperconectividad, el análisis de datos
        masivos y la automatización marcarán el futuro. Sin embargo, los planes
        de estudio todavía avanzan mucho más despacio de lo que exige el mundo
        actual.
      </p>

      <p>
        No debemos caer en el error de pensar que educar hoy a nuestros hijos
        como se nos educó a nosotros sigue siendo suficiente. Nuestros hijos
        necesitan conocer las nuevas tecnologías para apoyarse en ellas,
        comprenderlas y utilizarlas con criterio. El problema es evidente: gran
        parte de la estructura educativa, tanto pública como privada, no dispone
        todavía de la preparación necesaria para impartir ciertas materias con
        profundidad, y además su implantación resulta costosa para la
        administración.
      </p>

      <p>
        La electrónica es básica hoy y lo seguirá siendo mañana. Todos los
        componentes que sostienen nuestro mundo hiperconectado se basan en ella,
        y eso no va a cambiar. Electricidad básica, programación, sensores y
        actuadores forman parte de casi todos los dispositivos que utilizamos a
        diario. Entender estos fundamentos es entender cómo funciona el mundo
        que nos rodea.
      </p>

      <p>
        La inteligencia artificial merece una atención especial. No se trata
        solo de usar una IA para que nos devuelva una imagen modificada o un
        texto revisado a partir de un prompt. Se trata de comprender cómo
        funciona realmente, cuáles son sus límites de software y hardware, y
        cómo implantar nuestros propios modelos fuera de contextos cerrados,
        sesgos o restricciones ajenas a nuestras necesidades.
      </p>

      <p>
        Y no podemos olvidar la ciberseguridad. La falta de conocimiento en este
        ámbito es evidente, y muchas veces da la sensación de que vivimos
        expuestos, como si estuviéramos continuamente a merced de quienes pueden
        comprometer nuestros datos. Robo de información sensible, cuentas
        bancarias, privacidad, identidad digital… Nos enfrentamos cada día a
        riesgos que ya no afectan solo al plano personal, sino también al
        empresarial. La ciberseguridad será, sin duda, uno de los grandes retos
        de los próximos años.
      </p>

      <p>
        Nuestros jóvenes viven en una época en la que, en muchos casos, no se
        les ha enseñado a tener paciencia, a sostener el esfuerzo o a dedicar
        tiempo prolongado a una actividad. Y ahí es precisamente donde está una
        de las claves: la motivación. Un niño o un adolescente suficientemente
        motivado tiene una enorme capacidad para comprender conceptos nuevos,
        incluso abstractos, a veces mejor que muchos adultos. Por eso resulta
        necesario aplicar nuevas formas de enseñanza, más vivas, más prácticas y
        más conectadas con su realidad.
      </p>

      <p>
        Por todas estas razones, y también como padre, fui consciente del
        desafío que representa el futuro de mi hijo. Comprendí que, si no se
        despertaba a tiempo su curiosidad y su interés por estas áreas, quizá no
        estaría preparado para el mundo que viene. Y por eso, aun dedicándome
        profesionalmente al ámbito de la tecnología y la información, decidí
        crear M3.
      </p>

      <p>
        M3 es un proyecto con el que me propongo enseñar a niños y jóvenes las
        tecnologías que marcarán el mañana, desde una perspectiva motivadora y
        adaptada a cada edad. Con el método M3, el alumno aprenderá cuáles son
        las raíces del futuro tecnológico y desarrollará esa semilla de
        curiosidad que está en la base de todo aprendizaje y de toda evolución.
      </p>

      <p style={{ fontWeight: "bold", marginTop: 24 }}>
        Si alguna vez, como padre o madre, has tenido la sensación de que a tu
        hijo le faltan herramientas para afrontar el futuro que se le viene
        encima, este es vuestro sitio.
      </p>
      <p style={{ fontWeight: "bold", marginTop: 24 }}>MIGUEL MARÍN SIMÓN   </p>
      <p style={{ fontWeight: "bold", marginTop: 24 }}>FUNDADOR DE M3</p>

     <div style={{ textAlign: "center", marginTop: 40, marginBottom: 20 }}>
        <img
          src={logo}
          alt="Logo M3"
          style={{
            width: "220px",
            maxWidth: "80%",
            height: "auto",
          }}
        />
      </div>

    </div>

     </div>



  );
}